import React from "react";

export default function CustomLayer2Main() {
  return (
    <>
      <section className="glance-section centred py_100">
        <div className="auto-container">
          <div className="inner-container">
            <div className="pattern-layer">
              <div
                className="pattern-1"
                style={{
                  backgroundImage: 'url("assets/images/shape/shape-5.png")',
                }}
              />
              <div
                className="pattern-2"
                style={{
                  backgroundImage: 'url("assets/images/shape/shape-6.png")',
                }}
              />
              <div
                className="pattern-3 rotate-me"
                style={{
                  backgroundImage: 'url("assets/images/shape/shape-7.png")',
                }}
              />
              <div
                className="pattern-4 rotate-me"
                style={{
                  backgroundImage: 'url("assets/images/shape/shape-8.png")',
                }}
              />
              <div
                className="pattern-5 rotate-me"
                style={{
                  backgroundImage: 'url("assets/images/shape/shape-9.png")',
                }}
              />
            </div>
            <div className="sec-title light mb_80">
              <h2>Why Choose Cardano for Your Blockchain Project?</h2>
              <p>
                Cardano stands out for its unique proof-of-stake (PoS) consensus
                mechanism, which provides a sustainable, eco-friendly solution
                for blockchain projects. Built on peer-reviewed research and
                developed through a rigorous academic process, Cardano offers
                scalability, security, and interoperability, making it ideal for
                DApps, DeFi solutions, and tokenized applications.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
